import useApi, {
  useApiCreate,
  useApiSingle,
  useApiUpdate,
  useFirstFromList,
} from '@/composables/api'
import { User } from '@/model/data-object/User'
import { RecentUserChanges } from '@/model/data-object/RecentUserChanges'
import { UserChange } from '@/model/data-object/UserChange'
import { UserUpdate } from '@/model/data-object/UserUpdate'

function fetchCurrent() {
  return useApi<User>('/api/prv/v1/user/current')
}

function fetchSpecific(userId: number) {
  return useFirstFromList<User>('/api/pub/v1/user/ids/' + userId, {})
}

function updateUser(userUpdate: UserUpdate, userId: number) {
  return useApiUpdate<User>('/api/prv/v1/user/' + userId, userUpdate)
}

function fetchChangeRequests() {
  return useApiSingle<RecentUserChanges>('/api/prv/v1/userChange', {})
}

function postChangeRequest(userChange: UserChange) {
  return useApiCreate<UserChange>('/api/prv/v1/userChange', userChange)
}

export default function useUsersApi() {
  return {
    fetchCurrent,
    fetchSpecific,
    fetchChangeRequests,
    postChangeRequest,
    updateUser,
  }
}
